import * as Models from '../../../models';
import { Error, ErrorTargets } from '../../../models/response';
import { getExams } from './get-exams';

const FULL_PAGE_SIZE = 100;

export type GetExamParams = {
  examId: Models.ExamId;
  oppositionId?: Models.OppositionId;
  type?: Models.AvailableExamTypes;
};

export const getExam = (params: GetExamParams): Promise<Models.Exam> => {
  const { examId, oppositionId, type } = params;
  const promise = new Promise<Models.Exam>(
    (resolve, reject: (error: Error<404, 'NotFound', ErrorTargets.Exam>) => void) => {
      // TODO: Move this logic to a new backend endpoint
      const findExamPageByPage = (page: number = 1): Promise<Models.Exam | undefined> => {
        return getExams({ oppositionId, type, page, pageSize: FULL_PAGE_SIZE }).then(response => {
          const found = response.resources.find(exam => exam.id === examId);

          if (!found && page < response.paginator.pages) {
            return findExamPageByPage(page + 1);
          }

          if (!found) {
            reject({
              status: 404,
              code: 'NotFound',
              message: `Exam with id ${examId} not found`,
              target: ErrorTargets.Exam,
            });
          }

          resolve(found!);
        });
      };

      return findExamPageByPage();
    },
  );

  return promise;
};
